import React from 'react';
import './FrontPage.css';

function FrontPage () {
  return (
    <div className="Home">
      <div className="Main">
        <h1 className="Welcome">Welcome</h1>
        <h2>Blackfoot Revitalization Project</h2>
        <div className="Intro">
          <p>Our goal is to build technologically innovative language learning tools to aid in the revitalization and preservation of the Blackfoot language</p>
        </div>
      </div>
    </div>
  );
}

export default FrontPage;
